const EBOOK_CATEGORIES = [
  { slug: "macibu-gramatas", title: "Mācību grāmatas" },
  { slug: "rokasgramatas", title: "Rokasgrāmatas" },
  { slug: "uzdevumu-krajumi", title: "Uzdevumu krājumi" },
]
const WORKSHEET_CATEGORIES = [{ slug: "drukajamas-darba-lapas", title: "Darba lapas" }]
const TEACHING_AIDS_CATEGORIES = [{ slug: "metodiskie-lidzekli", title: "Metodiskie līdzekļi" }]
const VIDEO_CATEGORIES = [{ slug: "video", title: "Video" }]
const ACTIVE_INSPIRE = [{ slug: "interaktivie-materiali", title: "Interaktīvie Materiali" }]

export { EBOOK_CATEGORIES, WORKSHEET_CATEGORIES, TEACHING_AIDS_CATEGORIES, VIDEO_CATEGORIES, ACTIVE_INSPIRE }
